import { createContext, useEffect, useState } from "react";
import axios from "axios";
import { useNavigate} from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { getAPI } from "../Global";
import { toast } from "react-toastify";
const AuthContext = createContext();

export default AuthContext;

export const AuthProvider = ({ children }) => {
  let [authToken, setAuthToken] = useState(() =>
    localStorage.getItem("authToken")
      ? JSON.parse(localStorage.getItem("authToken"))
      : ""
  );
  let [user, setUser] = useState(() =>
    localStorage.getItem("authToken")
      ? jwtDecode(localStorage.getItem("authToken"))
      : {}
  );
  let navigate = useNavigate();
  let [loading, setLoading] = useState(true);

  let loginUser = (e) => {
    e.preventDefault();
    axios
      .post(getAPI("token"), {
        phone_no: e.target.username.value,
        password: e.target.password.value,
      })
      .then((response) => {
        checkSuperUser(response.data.access);
        setAuthToken(response.data);
        setUser(jwtDecode(response.data.access));
        localStorage.setItem("authToken", JSON.stringify(response.data));
      })
      .catch((error) => {
        toast.error("Username or password incorrect");
        console.error(error);
      });
  };

  let checkSuperUser = async (token)=>{
    await axios
    .get(getAPI("isSuperUser"),  {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      if(response.data.is_superuser){
        toast.success("Welcome, Admin");
      }else{
        setAuthToken({});
        setUser({});
        localStorage.removeItem("authToken");
        navigate("login");
        toast.error("User is not super user");
      }
    })
    .catch((error) => {
      toast.error("Username or password incorrect");
      console.error(error);
    });
  }


  let checkSuperUserRefresh = async (token)=>{
    await axios
    .get(getAPI("isSuperUser"),  {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      if(response.data.is_superuser){
      }else{
        setAuthToken({});
        setUser({});
        localStorage.removeItem("authToken");

        toast.error("User is not super user");
      }
    })
    .catch((error) => {
      toast.error("Username or password incorrect");
      console.error(error);
    });
  }

  let refreshToken = () => {
    if (authToken?.refresh) {
      
      axios
        .post(getAPI("refreshToken"), { refresh: `${authToken.refresh}` })
        .then((response) => {
          checkSuperUserRefresh(response.data.access);
          setAuthToken(response.data);
          setUser(jwtDecode(response.data.access));
          localStorage.setItem("authToken", JSON.stringify(response.data));
        })
        .catch((error) => {
          logOutUser();
        });
    } else {
      logOutUser();
    }

    if (loading) {
      setLoading(false);
    }
  };

  let logOutUser = () => {
    setAuthToken({});
    setUser({});
    localStorage.removeItem("authToken");
    navigate("login");
  };

  let contextData = {
    user: user,
    loginUser: loginUser,
    logOutUser: logOutUser,
    authToken: authToken,
  };

  useEffect(() => {
    if (loading) {
      refreshToken();
    }

    // Listen for storage events to update token when refreshed by apiClient
    const handleStorageChange = (e) => {
      if (e.key === 'authToken' && e.newValue) {
        const newTokenData = JSON.parse(e.newValue);
        setAuthToken(newTokenData);
        setUser(jwtDecode(newTokenData.access));
      }
    };
    
    window.addEventListener('storage', handleStorageChange);

    let fourMinutes = 1000 * 60 * 4;
    let interval = setInterval(() => {
      if (authToken) {
        refreshToken();
      }
    }, fourMinutes);
    
    return () => {
      clearInterval(interval);
      window.removeEventListener('storage', handleStorageChange);
    };
  }, [authToken, loading]);

  return (
    <AuthContext.Provider value={contextData}>
      {loading ? null : children}
    </AuthContext.Provider>
  );
};
